import { ButtonContent } from "../AdminReportStyle";
import { Dialog } from "primereact/dialog";
import {
  ColumnZeroReport,
  ContentZeroReport,
  LengthZeroContainer,
  LengthZeroReport,
  TitleZeroReport,
} from "./ModalLengthZero.Styled";
import IMGNotFoundTalma from "../../../images/img_not_found_talma.png";
interface Props {
  showModalLengthZero: boolean;
  onAccept: () => void;
}

export const ModalLengthZero = ({
  showModalLengthZero = false,
  onAccept,
}: Props) => {
  return (
    <Dialog
      style={{ width: "48.3rem", height: "32rem" }}
      className="img-processing-talma-class"
      showHeader={false}
      visible={showModalLengthZero}
      onHide={() => {}}
      draggable={false}
      resizable={false}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        <LengthZeroReport>
          <img
            src={IMGNotFoundTalma}
            alt="download"
            className="img-processing-report"
          />
        </LengthZeroReport>
      </div>
      <LengthZeroContainer>
        <ColumnZeroReport>
          <TitleZeroReport>
            ¡Oh no! No se han encontrado registros.
          </TitleZeroReport>
          <ContentZeroReport>
            No se pudo encontrar la información con los filtros ingresados.
            Realice una nueva búsqueda con uno o más filtros.
          </ContentZeroReport>
          <div style={{ display: "flex", marginTop: "1.4rem" }}>
            <ButtonContent
              onClick={() => {
                onAccept();
              }}
              backgroundColor="#76BC21"
              width="43rem"
              height="5.6rem"
            >
              {"Entendido"}
            </ButtonContent>
          </div>
        </ColumnZeroReport>
      </LengthZeroContainer>
    </Dialog>
  );
};
